import { getEmailDraftInfo } from "@app/store/email";
import useSelectorWithArgs from "@app/util/redux/useSelectorWithArgs";

const useEmailDraftInfoGetter = () => {
  return useSelectorWithArgs(getEmailDraftInfo);
};

export default useEmailDraftInfoGetter;
